<app-navbar *ngIf="showBars()" (menuClick)="toggleSidebar()"></app-navbar>
<div *ngIf="showBars()" class="flex 2xl:px-16 lg:px-10 md:px-10 px-4 2xl:pt-3 lg:pt-0">
    <app-sidebar class="lg:block hidden sticky" [minimized]="minimizeSidebar" (toggleMinimize)="toggleMinimize($event)" [opened]="true"></app-sidebar>
    <app-sidebar class="lg:hidden" [opened]="sidebarOpen" (close)="sidebarOpen = false"></app-sidebar>
    <div class="w-full h-full 2xl:ps-9 lg:ps-8 mb-5" [ngClass]="minimizeSidebar ? 'lg:w-[calc(100%-54px)]' : 'xl:w-[calc(100%-14.5rem)] lg:w-[calc(100%-16rem)]'">
        <router-outlet></router-outlet>
        <div class="flex flex-col sm:flex-row justify-between items-center gap-2 text-start text-[#b1b1b1] 2xl:text-sm text-xs mt-10 font-light">
            <p dir="ltr">
              Developed and managed by
              <a href="https://www.devzonez.com/" target="_blank" rel="noopener noreferrer" class="text-[#2c72ff]">Devzonez</a>
            </p>
            <p dir="ltr">© 2025 Cadouh. All rights reserved.</p>
        </div>
    </div>
</div>

<router-outlet *ngIf="!showBars()"></router-outlet>
<app-toast-notifications-container></app-toast-notifications-container>
